export const opérateurParDéfaut = "||";

export const classeDeMotValeurs = new Map([
    ["adjectif", ["adjectif", "adjectif_numéral_ordinal", "adjectif_fractionnaire", "adjectif_possessif"]],
    ["adverbe", ["adverbe", "adverbe_complexe"]],
    ["conjonction", ["conjonction_de_coordination","conjonction_de_subordination", "conjonction_de_coordination_complexe", "conjonction_de_subordination_complexe"]],
    ["déterminant", ["déterminant_numéral", "déterminant_indéfini", "déterminant_possessif",
                    "déterminant_défini", "déterminant_défini_contracté", "déterminant_démonstratif"]],
    ["interjection", ["interjection","interjection_complexe"]],
    ["nom", ["nom", "nom_propre"]],
    ["nom commun", ["nom"]],
    ["nom propre", ["nom_propre"]],
    ["préposition", ["préposition", "préposition_complexe"]],
    ["pronom", ["pronom_personnel", "pronom_indéfini", "pronom_numéral", "pronom_relatif"
        , "pronom_interrogatif", "pronom_démonstratif", "pronom_possessif", "pronom_indéfini_complexe"]],
    ["verbe", ["verbe"]],
]);

export const genreValeurs = new Map([
    ["masculin", ["m"]],
    ["féminin", ["f"]],
    ["masculin ou féminin", ["m_ou_f"]],
    ["épicène", ["épicène"]],
]);

export const nombreValeurs = new Map([
    ["singulier", ["s"]],
    ["pluriel", ["p"]],
    ["invariable", ["inv"]],
]);

export const listeMEQValeurs = new Map([
    ["1re année primaire", ["MEQ_LISTE_PRIMAIRE_01"]],
    ["2e année primaire", ["MEQ_LISTE_PRIMAIRE_02"]],
    ["3e année primaire", ["MEQ_LISTE_PRIMAIRE_03"]],
    ["4e année primaire", ["MEQ_LISTE_PRIMAIRE_04"]],
    ["5e année primaire", ["MEQ_LISTE_PRIMAIRE_05"]],
    ["6e année primaire", ["MEQ_LISTE_PRIMAIRE_06"]],
]);

export const modeValeurs = new Map([
    ["indicatif", ["indicatif"]],
    ["subjonctif", ["subjonctif"]],
    ["participe", ["participe"]],
    ["impératif", ["impératif"]],
    ["infinitif", ["infinitif"]],
]);

export const tempsValeurs = new Map([
    ["présent", ["présent"]],
    ["imparfait", ["imparfait"]],
    ["futur simple", ["futur_simple"]],
    ["conditionnel présent", ["conditionnel_présent"]],
    ["passé simple", ["passé_simple"]],
    ["passé", ["passé"]],
]);

export const personneValeurs = new Map([
    ["1re", ["1"]],
    ["2e", ["2"]],
    ["3e", ["3"]],
]);

export const typeMotValeurs = new Map([
    ["mot plein", ["oui"]],
    ["mot outil", ["non"]],
]);

export const rectificationOrthographiqueValeurs = new Map([
    ["oui", ["oui","création","choisi"]]
]);

export const modèleDeConjugaisonValeurs = new Map([
    ["accroire", ["200-accroire"]],
    ["acheter", ["34-acheter","35-cliqueter","32-ensorceler","31-geler","30-lever"]],
    ["aimer", ["1-aimer","17-arguer","15-baigner","18-créer","20-essayer","16-fatiguer","19-grasseyer","13-oublier","14-travailler"]],
    ["aller", ["37-aller"]],
    ["apercevoir", ["87-apercevoir"]],
    ["appeler", ["33-appeler","32-ensorceler"]],
    ["asseoir", ["94-asseoir"]],
    ["atteindre", ["113-atteindre"]],
    ["avoir", ["11-avoir"]],
    ["battre", ["104-battre"]],
    ["bienvenir", ["201-bienvenir"]],
    ["boire", ["81-boire"]],
    ["bouillir", ["44-bouillir"]],
    ["céder", ["26-tolérer"]],
    ["chaloir", ["202-chaloir"]],
    ["choir", ["98-choir"]],
    ["clore", ["101-clore"]],
    ["commencer", ["24-tracer"]],
    ["connaître", ["75-connaître","78-accroître","77-repaître"]],
    ["conquérir", ["53-conquérir"]],
    ["coudre", ["110-coudre"]],
    ["courir", ["51-courir"]],
    ["courre", ["203-courre"]],
    ["croire", ["80-croire"]],
    ["croître", ["79-croître"]],
    ["cueillir", ["40-cueillir"]],
    ["déchoir", ["100-déchoir"]],
    ["dépecer", ["29-dépecer"]],
    ["devoir", ["82-devoir"]],
    ["dire", ["63-dire"]],
    ["dissoudre", ["111-dissoudre"]],
    ["dormir", ["46-dormir"]],
    ["échoir", ["99-échoir"]],
    ["écrire", ["68-écrire"]],
    ["émouvoir", ["84-émouvoir"]],
    ["employer", ["21-ennuyer","20-essayer","22-noyer"]],
    ["envoyer", ["23-envoyer"]],
    ["être", ["12-être"]],
    ["exclure", ["102-exclure"]],
    ["faire", ["72-faire"]],
    ["falloir", ["91-falloir"]],
    ["finir", ["38-finir","56-amuïr","43-faillir"]],
    ["forfaire", ["204-forfaire"]],
    ["foutre", ["105-foutre"]],
    ["frire", ["65-frire"]],
    ["fuir", ["55-fuir"]],
    ["gésir", ["54-gésir"]],
    ["haïr", ["57-haïr"]],
    ["jeter", ["36-jeter","35-cliqueter"]],
    ["lire", ["62-lire"]],
    ["manger", ["25-nager"]],
    ["mettre", ["103-mettre"]],
    ["moudre", ["109-moudre"]],
    ["mourir", ["52-mourir"]],
    ["naître", ["76-naître"]],
    ["nuire", ["59-nuire"]],
    ["occire", ["205-occire"]],
    ["ouïr", ["58-ouïr"]],
    ["ouvrir", ["39-ouvrir"]],
    ["paître", ["206-paître"]],
    ["2.partir", ["207-partir"]],
    ["plaire", ["74-plaire"]],
    ["pleuvoir", ["83-pleuvoir"]],
    ["pourvoir", ["90-pourvoir"]],
    ["pouvoir", ["85-pouvoir"]],
    ["prédire", ["64-prédire"]],
    ["prendre", ["108-prendre"]],
    ["prévaloir", ["208-prévaloir"]],
    ["prévoir", ["89-prévoir"]],
    ["produire", ["61-produire"]],
    ["protéger", ["27-protéger"]],
    ["quérir", ["209-quérir"]],
    ["rapiécer", ["28-rapiécer"]],
    ["ravoir", ["210-ravoir"]],
    ["rendre", ["107-vendre"]],
    ["résoudre", ["112-résoudre"]],
    ["ressoudre", ["211-ressoudre"]],
    ["rire", ["67-rire"]],
    ["rompre", ["106-rompre"]],
    ["saillir", ["42-saillir"]],
    ["savoir", ["86-savoir"]],
    ["sentir", ["48-sentir"]],
    ["seoir", ["97-seoir","96-messeoir"]],
    ["servir", ["47-servir"]],
    ["sourdre", ["212-sourdre"]],
    ["soustraire", ["71-soustraire"]],
    ["stupéfaire", ["213-stupéfaire"]],
    ["suffire", ["66-suffire","60-luire"]],
    ["suivre", ["70-suivre"]],
    ["surseoir", ["95-surseoir"]],
    ["taire", ["73-taire","74-plaire"]],
    ["tressaillir", ["41-tressaillir"]],
    ["vaincre", ["114-vaincre"]],
    ["valoir", ["92-valoir"]],
    ["venir", ["45-venir"]],
    ["vêtir", ["49-vêtir","50-revêtir"]],
    ["vivre", ["69-vivre"]],
    ["voir", ["88-voir"]],
    ["vouloir", ["93-vouloir"]]

]);


export const thème = new Map([
    ["alimentation", ["alimentation"]],
    ["amphibien", ["amphibien"]],
    ["anatomie", ["anatomie"]],
    ["animaux", ["animaux"]],
    ["arbre", ["arbre"]],
    ["architecture", ["architecture"]],
    ["arts", ["arts"]],
    ["botanique", ["botanique"]],
    ["bureautique", ["bureautique"]],
    ["couleur", ["couleur"]],
    ["couleurs", ["couleurs"]],
    ["cuisine", ["cuisine"]],
    ["économie", ["économie"]],
    ["éducation", ["éducation"]],
    ["faune", ["faune"]],
    ["finance", ["finance"]],
    ["flore", ["flore"]],
    ["fruit", ["fruit"]],
    ["géographie", ["géographie"]],
    ["géologie", ["géologie"]],
    ["habitation", ["habitation"]],
    ["histoire", ["histoire"]],
    ["informatique", ["informatique"]],
    ["insecte", ["insecte"]],
    ["insectes", ["insectes"]],
    ["jeux", ["jeux"]],
    ["justice", ["justice"]],
    ["légume", ["légume"]],
    ["loisir", ["loisir"]],
    ["machinerie", ["machinerie"]],
    ["maison", ["maison"]],
    ["médecine", ["médecine"]],
    ["musique", ["musique"]],
    ["oiseau", ["oiseau"]],
    ["oiseaux", ["oiseaux"]],
    ["plante", ["plante"]],
    ["poisson", ["poisson"]],
    ["poissons", ["poissons"]],
    ["politique", ["politique"]],
    ["religion", ["religion"]],
    ["reptile", ["reptile"]],
    ["reptiles", ["reptiles"]],
    ["santé", ["santé"]],
    ["science", ["science"]],
    ["spiritualité", ["spiritualité"]],
    ["sport", ["sport"]],
    ["technologie", ["technologie"]],
    ["transport", ["transport"]],
    ["zoologie", ["zoologie"]],

]);



export const meqComposition = new Map([
    ["juxtaposition", ["MEQ_COMPOSITION_JUXTAPOSITION"]],
    ["soudure", ["MEQ_COMPOSITION_SOUDURE"]],
    ["trait d'union", ["MEQ_COMPOSITION_TRAIT_D_UNION"]],
]);

export const meqDérivation = new Map([
    ["c muet", ["MEQ_DÉRIVATION_C_MUET"]],
    ["d muet", ["MEQ_DÉRIVATION_D_MUET"]],
    ["g muet", ["MEQ_DÉRIVATION_G_MUET"]],
    ["l muet", ["MEQ_DÉRIVATION_L_MUET"]],
    ["p muet", ["MEQ_DÉRIVATION_P_MUET"]],
    ["s muet", ["MEQ_DÉRIVATION_S_MUET"]],
    ["t muet", ["MEQ_DÉRIVATION_T_MUET"]],
]);

export const meqFormationDuFéminin = new Map([
    ["ajout d'un -e", ["MEQ_FORMATION_DU_FÉMININ_AJOUT_D_UN_E"]],
    ["aucun ajout à la finale en -e", ["MEQ_FORMATION_DU_FÉMININ_AUCUN_AJOUT_À_LA_FINALE_EN_E"]],
    ["doublement de la consonne finale et ajout d'un -e", ["MEQ_FORMATION_DU_FÉMININ_DOUBLEMENT_DE_LA_CONSONNE_FINALE_ET_AJOUT_D_UN_E"]],
    ["transformation de la finale", ["MEQ_FORMATION_DU_FÉMININ_TRANSFORMATION_DE_LA_FINALE"]],
    ["cas particuliers", ["MEQ_FORMATION_DU_FÉMININ_CAS_PARTICULIER"]],
]);

export const meqFormationDuPluriel = new Map([
    ["ajout d'un -s", ["MEQ_FORMATION_DU_PLURIEL_AJOUT_D_UN_S"]],
    ["ajout d'un -x", ["MEQ_FORMATION_DU_PLURIEL_AJOUT_D_UN_X"]],
    ["aucun ajout aux finales en -s, -x et -z", ["MEQ_FORMATION_DU_PLURIEL_AUCUN_AJOUT_AUX_FINALES_EN_S_X_Z"]],
    ["transformation en -aux", ["MEQ_FORMATION_DU_PLURIEL_TRANSFORMATION_EN_AUX"]],
]);

export const meqThème = new Map([
    ["activité physique", ["MEQ_THÈME_ACTIVITÉ_PHYSIQUE"]],
    ["alimentation", ["MEQ_THÈME_ALIMENTATION"]],
    ["ameublement", ["MEQ_THÈME_AMEUBLEMENT"]],
    ["animal", ["MEQ_THÈME_ANIMAL"]],
    ["art", ["MEQ_THÈME_ART"]],
    ["calendrier", ["MEQ_THÈME_CALENDRIER"]],
    ["corps", ["MEQ_THÈME_CORPS"]],
    ["couleur", ["MEQ_THÈME_COULEUR"]],
    ["école", ["MEQ_THÈME_ÉCOLE"]],
    ["émotion et sentiment", ["MEQ_THÈME_ÉMOTION_ET_SENTIMENT"]],
    ["famille", ["MEQ_THÈME_FAMILLE"]],
    ["fête", ["MEQ_THÈME_FÊTE"]],
    ["formule de politesse", ["MEQ_THÈME_FORMULE DE POLITESSE"]],
    ["lieu", ["MEQ_THÈME_LIEU"]],
    ["maison", ["MEQ_THÈME_MAISON"]],
    ["monde du livre", ["MEQ_THÈME_MONDE DU LIVRE"]],
    ["nature", ["MEQ_THÈME_NATURE"]],
    ["nombre", ["MEQ_THÈME_NOMBRE"]],
    ["temps", ["MEQ_THÈME_TEMPS"]],
    ["transport", ["MEQ_THÈME_TRANSPORT"]],
    ["travail", ["MEQ_THÈME_TRAVAIL"]],
    ["vêtement", ["MEQ_THÈME_VÊTEMENT"]],
]);

export const meqVariationEnGenre = new Map([
    ["double genre", ["MEQ_VARIATION_EN_GENRE_DOUBLE_GENRE_MASCULIN_OU_FÉMININ"]],
    ["masculin et féminin identiques à l'oral et à l'écrit", ["MEQ_VARIATION_EN_GENRE_MASCULIN_ET_FÉMININ_IDENTIQUES_À_L_ORAL_ET_À_L_ÉCRIT"]],
    ["masculin et féminin différents à l'écrit seulement", ["MEQ_VARIATION_EN_GENRE_MASCULIN_ET_FÉMININ_DIFFÉRENTS_À_L_ÉCRIT_SEULEMENT"]],
    ["masculin et féminin différents à l'oral et à l'écrit", ["MEQ_VARIATION_EN_GENRE_MASCULIN_ET_FÉMININ_DIFFÉRENTS_À_L_ORAL_ET_À_L_ÉCRIT"]],
]);

export const meqVariationEnNombre = new Map([
    ["toujours pluriel", ["MEQ_VARIATION_EN_NOMBRE_TOUJOURS_PLURIEL"]],
    ["singulier et pluriel identiques au masculin à l'oral et à l'écrit", ["MEQ_VARIATION_EN_NOMBRE_SINGULIER_ET_PLURIEL_IDENTIQUES_AU_MASCULIN_À_L_ORAL_ET_À_L_ÉCRIT"]],
    ["singulier et pluriel identiques au féminin à l'oral et à l'écrit", ["MEQ_VARIATION_EN_NOMBRE_SINGULIER_ET_PLURIEL_IDENTIQUES_AU_FÉMININ_À_L_ORAL_ET_À_L_ÉCRIT"]],
    ["singulier et pluriel différents à l'écrit seulement", ["MEQ_VARIATION_EN_NOMBRE_SINGULIER_ET_PLURIEL_DIFFÉRENTS_À_L_ÉCRIT_SEULEMENT"]],
    ["singulier et pluriel différents au masculin à l'oral et à l'écrit", ["MEQ_VARIATION_EN_NOMBRE_SINGULIER_ET_PLURIEL_DIFFÉRENTS_AU_MASCULIN_À_L_ORAL_ET_À_L_ÉCRIT"]],
]);

export const TypeSaisieValeur = Object.freeze({
    TEXTE: "TEXTE",
    CHOIX_UNIQUE: "CHOIX_UNIQUE",
    CHOIX_MULTIPLE: "CHOIX_MULTIPLE",
});


export const Événements = Object.freeze(
    {
        "NOUVEAU_CRITÈRE" : "nouveauCritère",
        "SUPPRESSION_CRITÈRE" : "suppressionCritère",
        "PAGINATION" : "paginationChange",
        "TRI" : "triChange",
        "NOUVELLE_RECHERCHE" : "nouvelleRecherche",
        "SUPPRESSION_RECHERCHE" : "suppressionRecherche",
        "NOUVELLES_DONNÉES" : "nouvellesDonnées"
    }
)

export const ÉvénementsGTM = Object.freeze(
    {
        "RECHERCHE" : {
            code: "recherches",
            actions : {
                MOTS : "mots",
                MOTS_LISTEMEQ : "mots_listeMEQ",
                RECHERCHE_FRUCTUEUSE : "recherche_fructueuse",
                RECHERCHE_INFRUCTUEUSE : "recherche_infructueuse"
            }},
        "CLIC" : {code: "clics",
            actions : {
                MOTS_ONGLET : "mots_onglet",
                MOTS_FAVORIS_AJOUTER : "mots_favoris_ajouter",
                MOTS_FAVORIS_SUPPRIMER : "mots_favoris_supprimer",
                MOTS_FAVORIS_RENOMMER : "mots_favoris_renommer"
            }},

    }
)


